<template>
  <b-card no-header no-footer>
    <ValidationObserver ref="form">
      <form @submit.prevent="onSubmit">
        <b-row>
          <b-col cols="12" md="12">
            <template
              v-for="(m, index) in filterModel([
                'kode_kegiatan_id',
                'uraian_kegiatan',
                'sumber_dana',
                'account_code_id',
              ])"
            >
              <div :key="index">
                <form-group-input
                  :ref="index"
                  :readonly="index === 'uraian_kegiatan' ? true : false"
                  :type="m.type"
                  :label="typeof m.label === 'string' ? m.label : null"
                  :options="
                    m.type === 'radio'
                      ? getClassicOptions(index)
                      : getOptions(index)
                  "
                  :need-label="true"
                  v-model="m.value"
                  :rules="typeof m.rules !== 'undefined' ? m.rules : null"
                  :disabled="
                    typeof m.disabled !== 'undefined' ? m.disabled : null
                  "
                  :id="index"
                />
              </div>
            </template>
            <b-row>
              <template
                v-for="(m, index) in filterModel([
                  'harga_satuan',
                  'jenis_satuan',
                  'total_harga',
                ])"
              >
                <b-col cols="12" md="4">
                  <div :key="index">
                    <form-group-input
                      :ref="index"
                      :type="m.type"
                      :label="typeof m.label === 'string' ? m.label : null"
                      :options="
                        m.type === 'radio'
                          ? getClassicOptions(index)
                          : getOptions(index)
                      "
                      :need-label="true"
                      v-model="m.value"
                      :rules="typeof m.rules !== 'undefined' ? m.rules : null"
                      :disabled="
                        typeof m.disabled !== 'undefined' ? m.disabled : null
                      "
                      :id="index"
                    />
                  </div>
                </b-col>
              </template>
            </b-row>
            <b-row>
              <template
                v-for="(m, index) in filterModel([
                  'volume',
                  'frekuensi',
                  'bulan_kegiatan',
                ])"
              >
                <b-col cols="12" md="4">
                  <div :key="index">
                    <form-group-input
                      :ref="index"
                      :type="m.type"
                      :label="typeof m.label === 'string' ? m.label : null"
                      :multiple="typeof m.multiple !== 'undefined' ? m.multiple : false"
                      :options="
                        m.type === 'radio'
                          ? getClassicOptions(index)
                          : getOptions(index)
                      "
                      :need-label="true"
                      v-model="m.value"
                      :rules="typeof m.rules !== 'undefined' ? m.rules : null"
                      :disabled="
                        typeof m.disabled !== 'undefined' ? m.disabled : null
                      "
                      :id="index"
                    />
                  </div>
                </b-col>
              </template>
            </b-row>
            <b-row>
              <b-col cols="12">
                <div class="mt-2 mb-2">
                  <b-button
                    @click.prevent="addNewDetail()"
                    size="small"
                    variant="info"
                    ><font-awesome-icon icon="plus"></font-awesome-icon> Detail</b-button
                  >
                </div>
                <table class="table">
                  <tr>
                    <th width="15%">Bulan<span class="text-danger">*</span></th>
                    <th width="20%">Harga Satuan<span class="text-danger">*</span></th>
                    <th width="15%">Jenis Satuan<span class="text-danger">*</span></th>
                    <th  width="20%">Total Harga<span class="text-danger">*</span></th>
                    <th  width="15%">Volume<span class="text-danger">*</span></th>
                    <th  width="15%">Frekuensi</th>
                    <th  width="5%"></th>
                  </tr>
                  <tr v-for="(detail, index) in formDetail" :key="index">
                    <td>
                      <!-- <form-group-input
                        :noMarg="true"
                        type="enum"
                        label="Bulan"
                        :options="objectToOptions(bulanKegiatan)"
                        :selectable="option => !selectedBulanKegiatan.includes(option.value)"
                        
                        v-model="detail.bulan_kegiatan"
                        :need-label="false"
                        :rules="'required'"
                        :ref="'detail_bulan_kegiatan_' + index"
                        :id="'detail_bulan_kegiatan_' + index"
                      /> -->
                      <v-select
                        :disabled="detail.bulan_kegiatan !== null"
                        :clearable="false"
                        :options="objectToOptions(bulanKegiatan)"
                        v-model="detail.bulan_kegiatan"
                        :reduce="option => option.value"
                        :selectable="option => !selectedBulanKegiatan.includes(option.value)"
                        :ref="'detail_bulan_kegiatan_' + index"
                        :id="'detail_bulan_kegiatan_' + index"
                        :required="true"
                      />
                    </td>
                    <td>
                      <form-group-input
                        :noMarg="true"
                        text-align="right"
                        type="price"
                        label="Harga satuan"
                        v-model="detail.harga_satuan"
                        :need-label="false"
                        :rules="'required'"
                        :ref="'detail_harga_satuan_' + index"
                        :id="'detail_harga_satuan_' + index"
                      />
                    </td>
                    <td>
                      <form-group-input
                        :noMarg="true"
                        type="text"
                        label="Jenis satuan"
                        v-model="detail.jenis_satuan"
                        :need-label="false"
                        :rules="'required'"
                        :ref="'detail_jenis_satuan_' + index"
                        :id="'detail_jenis_satuan_' + index"
                      />
                    </td>
                    <td>
                      <form-group-input
                        :noMarg="true"
                        text-align="right"
                        type="price"
                        label="Total Harga"
                        v-model="detail.total_harga"
                        :need-label="false"
                        :rules="'required'"
                        :ref="'detail_total_harga_' + index"
                        :id="'detail_total_harga_' + index"
                      />
                    </td>
                    <td>
                      <form-group-input
                        :noMarg="true"
                        type="text"
                        label="Volume"
                        v-model="detail.volume"
                        :need-label="false"
                        :rules="'required'"
                        :ref="'detail_volume_' + index"
                        :id="'detail_volume_' + index"
                      />
                    </td>
                    <td>
                      <form-group-input
                        :noMarg="true"
                        type="text"
                        label="Frekuensi"
                        v-model="detail.frekuensi"
                        :need-label="false"
                        :rules="null"
                        :ref="'detail_frekuensi_' + index"
                        :id="'detail_frekuensi_' + index"
                      />
                    </td>
                    <td>
                      <b-button
                        @click.prevent="removeDetailindex(index)" size="small" variant="danger">
                        <font-awesome-icon icon="trash"></font-awesome-icon>
                      </b-button>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="7" align="right">
                      Total Harga Rp. {{ sumAllTotalHarga > 0 ? $formatPrice(sumAllTotalHarga) : 0 }}
                    </td>
                  </tr>
                </table>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <div>
          <b-button type="submit" variant="primary" class="mt-0"
            ><font-awesome-icon
              icon="spinner"
              spin
              v-if="isLoading"
            ></font-awesome-icon>
            Simpan</b-button
          >
          <b-button
            :to="'/rencana'"
            variant="secondary"
            class="ml-3 float-right"
            ><font-awesome-icon
              icon="spinner"
              spin
              v-if="isLoading"
            ></font-awesome-icon>
            Batal</b-button
          >
        </div>
      </form>
    </ValidationObserver>
  </b-card>
</template>

<script>
import {
  saveProcess,
  setModelValue,
  cleanIdrFormat,
  scrollToError,
  objectToOptions,
  classicObjectToOptions,
} from "@/_helpers";
import formGroupInput from "@/components/FormGroupInput.vue";
import Planning from "@/models/Planning.js";
import Rekening from "@/models/Rekening.js";
import KodeKegiatan from "@/models/KodeKegiatan.js";

const planningModel = new Planning();
const rekeningModel = new Rekening();
const kodeKegiatanModel = new KodeKegiatan();
const formDetail = {
  bulan_kegiatan: null,
  harga_satuan: null,
  jenis_satuan: null,
  total_harga: null,
  volume: null,
  frekuensi: null
};

export default {
  components: {
    formGroupInput,
  },
  watch: {
    "$route.params.id": function (val) {
      if (this.mode === "update") {
        this.getDetail();
      }
    },
    totalPromiseAreaCount: async function (val) {
      if (val >= 4) {
        this.initEdit = false;
      }
    },
    'planningModel.kode_kegiatan_id.value': function (val) {
      if (val) {
        const kodeKegiatanFiltered = this.list.kodeKegiatan.filter(kodeKegiatan => {
          return kodeKegiatan.id === val
        });
        if (kodeKegiatanFiltered.length) {
          this.planningModel.uraian_kegiatan.value = kodeKegiatanFiltered[0].description
        }
      }
    },
    'formDetail': function (val) {
      this.formDetail.forEach((detail, index) => {
        if (detail.bulan_kegiatan !== null) {
          this.selectedBulanKegiatan.push(detail.bulan_kegiatan)
        }
      })
    }
    // this.list.kodeKegiatan
  },
  computed: {
    mode: function () {
      return this.$route.params.id !== undefined ? "update" : "create";
    },
    sumAllTotalHarga: function () {
      return this.formDetail.reduce((accumuator, value) => {
        return accumuator + this.$priceToInt(value.total_harga)
      }, 0)
    }
  },
  data() {
    return {
      totalPromiseAreaCount: 0,
      initEdit: false,
      isLoading: false,
      planningModel: planningModel.init(),
      rekeningModel: rekeningModel.init(),
      formDetail: [],
      bulanKegiatan: {
        '01-01': 'Januari',
        '02-01': 'Februari',
        '03-01': 'Maret',
        '04-01': 'April',
        '05-01': 'Mei',
        '06-01': 'Juni',
        '07-01': 'Juli',
        '08-01': 'Agustus',
        '09-01': 'September',
        '10-01': 'Oktober',
        '11-01': 'November',
        '12-01': 'Desember',
      },
      selectedBulanKegiatan: [],
      list: {
        kodeKegiatan: [],
        kodeRekening: [],
        sumberDana: []
      }
    };
  },
  mounted() {
    this.getAccountCodes();
    this.getKodeKegiatan();
    this.getSumberDana();

    if (this.mode === "update") {
      this.planningModel.sumber_dana.type = 'hidden'
      this.getDetail();
    } else {
      this.addNewDetail(true)
    }
  },
  methods: {
    filterModel(search) {
      const filtered = Object.entries(this.planningModel).filter((mdl) => {
        return search.includes(mdl[0]);
      });
      let result = {};
      filtered.forEach((element) => {
        result[element[0]] = element[1];
      });
      return result;
    },
    async getSumberDana() {
      return new Promise((resolve) => {
        this.$http.get("/json/sumberDana.json").then((resp) => {
          this.planningModel.sumber_dana.options = resp.data.data;
          return resolve();
        });
      })
    },
    async getKodeKegiatan() {
      return new Promise((resolve) => {
        kodeKegiatanModel
          .list({
            // parent_only: 1,
            list_items: 1,
            limit: 200,
          })
          .then((resp) => {
            let data = [];
            resp.data.forEach((d) => {
              data[d.id] = d.code + ' - ' + d.name;
            });

            this.planningModel.kode_kegiatan_id.options = data;
            this.list.kodeKegiatan = resp.data;
            return resolve()
          });
      });
    },
    async getAccountCodes() {
      return new Promise((resolve) => {
        rekeningModel
          .list({
            // parent_only: 1,
            list_items: 1,
            limit: 200,
          })
          .then((resp) => {
            let data = [];
            resp.data.filter(d => {
              return !d.parent_id
            }).forEach((d) => {
              data[d.id + '-disabled-it'] = d.code + ' - ' + d.name;
              resp.data.filter(dChild => {
                return dChild.parent_id === d.id
              }).forEach((dChild) => {
                data[dChild.id] = ' - ' + dChild.code + ' - ' + dChild.name;
              });
            });

            this.planningModel.account_code_id.options = data;
            this.list.kodeRekening = resp.data;
            return resolve()
          });
      });
    },
    getOptions(key) {
      return typeof this.planningModel[key].options !== "undefined"
        ? objectToOptions(this.planningModel[key].options)
        : null;
    },
    getClassicOptions(key) {
      return typeof this.planningModel[key].options !== "undefined"
        ? classicObjectToOptions(this.planningModel[key].options)
        : null;
    },
    objectToOptions (val) {
      return objectToOptions(val)
    },
    resetForm() {
      this.$nextTick(() => {
        // clearModelValue(this.planningModel)
        Object.keys(this.planningModel).forEach((key) => {
          this.$refs[key][0].setValue(null);
        });
        this.$refs.form.reset();
      });
    },
    getDetail() {
      this.initEdit = true;
      this.isLoading = true;
      planningModel
        .find(this.$route.params.id, {
          need_detail: 1,
        })
        .then((resp) => {
          this.isLoading = false;
          Object.keys(this.planningModel).forEach((key) => {
            if (typeof this.$refs[key] !== "undefined") {
              this.$refs[key][0].setValue(resp[key]);
            }
          });
          resp.details.forEach((detail) => {
            this.addNewDetail(true)
          });
          setTimeout(() => {
            resp.details.forEach((detail, index) => {
              detail.bulan_kegiatan = this.$moment(detail.bulan_kegiatan).format('MM-DD');
              detail.harga_satuan = this.$formatPrice(detail.harga_satuan);
              detail.total_harga = this.$formatPrice(detail.total_harga);
              Object.keys(formDetail).forEach((formDetailKey) => {
                if (formDetailKey === 'bulan_kegiatan') {
                  this.formDetail[index].bulan_kegiatan = detail.bulan_kegiatan
                } else {
                  this.$refs['detail_' + formDetailKey + '_' + index][0].setValue(detail[formDetailKey]);
                }
              });
            })
          }, 500);
        })
        .catch((error) => {
          if (process.env.NODE_ENV !== "production") {
            console.error(error);
          }
          this.isLoading = false;
        });
    },
    addNewDetail (init = false) {
      const hasEmptyBulanKegiatan = this.formDetail.filter(detail => detail.bulan_kegiatan === null).length > 0
      if (!init && hasEmptyBulanKegiatan) {
        alert('Isi terlebih dahulu bulan yang kosong!')
        return
      }
      
      const cloneFormDetail = { ...formDetail };
      this.formDetail.push(cloneFormDetail);
    },
    removeDetailindex (index) {
      if (this.formDetail.length > 1) {
        if (this.formDetail[index].bulan_kegiatan !== null) {
          const indexBulanKegiatan = this.selectedBulanKegiatan.indexOf(this.formDetail[index].bulan_kegiatan.value)
          this.selectedBulanKegiatan.splice(indexBulanKegiatan, 1);
        }
        
        this.formDetail.splice(index, 1);
      } else {
        alert('Detail Bulan Anggaran Minimal Satu!');
      }
    },
    onSubmit() {
      // let stopFormDetailForeach = false;
      // this.formDetail.forEach((formDetail, index) => {
      //   if (!stopFormDetailForeach) {
      //     Object.keys(formDetail).forEach(formDetailKey => {
      //       if (!stopFormDetailForeach && formDetailKey !== 'frekuensi') {
      //         if (!formDetail[formDetailKey] || (formDetail[formDetailKey] && !formDetail[formDetailKey].length) || formDetail[formDetailKey] === '') {
      //           console.log('detail_' + formDetailKey + '_' + index)
      //           document.getElementById('detail_' + formDetailKey + '_' + index).focus();
      //           stopFormDetailForeach = true;
      //         }
      //       }
      //     });
      //   }
      // });
      this.$refs.form.validate().then((success) => {
        if (!success || this.isLoading) {
          scrollToError(this.$refs.form);
          return false;
        }

        // cleanIdrFormat
        saveProcess(this.planningModel, this.mode === "update")
          .then((model) => {
            this.isLoading = true;
            const newformDetail = [];
            this.formDetail.forEach(formDetail => {
              newformDetail.push({
                ... formDetail,
                harga_satuan: cleanIdrFormat(formDetail.harga_satuan),
                total_harga: cleanIdrFormat(formDetail.total_harga),
              })
            });
            model.details = newformDetail
            // console.log(model)
            if (this.mode === "update") {
              planningModel
                .update(this.$route.params.id, model)
                .then(() => {
                  this.isLoading = false;
                  this.$store.dispatch(
                    "notification/success",
                    "Data rencana berhasil diubah."
                  );
                  this.$router.push("/rencana/" + this.$route.params.id);
                })
                .catch((error) => {
                  this.isLoading = false;
                  this.$store.dispatch("notification/error", error);
                });
            } else {
              planningModel
                .create(model)
                .then((resp) => {
                  this.isLoading = false;
                  this.$store.dispatch(
                    "notification/success",
                    "Data rencana berhasil disimpan."
                  );
                  // this.$router.push("/rencana/" + resp.id);
                  this.$router.push("/rencana");
                })
                .catch((error) => {
                  this.isLoading = false;
                  this.$store.dispatch("notification/error", error);
                });
            }
          })
          .catch(() => {});
      });
    },
  },
};
</script>